<style lang="scss" scoped>
.sync {
  float: right;
  background: #17cfb8;
  border-color: #17cfb8;
  i {
    font-size: 20px;
    vertical-align: -2px;
    margin-right: 5px;
  }
}
</style>

<template>
  <div>
    <div class="clearfix mb20">
      <el-radio-group v-model="type" @change="router">
        <el-radio-button :label="`/third/${id}/custom/index`">自定义菜单</el-radio-button>
      </el-radio-group>
      <el-button type="primary" class="sync" @click="asyncmaterial">
        <i class="iconfont icontongbubiaojiegou"></i>微信端素材同步
      </el-button>
    </div>
    <router-view ref="child"></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {},
  props: ['id'],
  data() {
    return {
      type: this.$route.path,
    };
  },
  mounted() {},
  methods: {
    router() {
      this.$router.push(this.type);
    },
    async asyncmaterial() {
      let res = await this.$http.get(`/api/${this.id}/material/async`);
      if (res) {
        await this.$refs.child.getData();
        this.$message.success('同步成功');
      }
    },
  },
};
</script>
